import React from 'react';
import { SizeOption, TitleVariant } from '@/services/enums';

interface AnimatedTitleProps {
  children: React.ReactNode;
  className?: string;
  variant?: TitleVariant;
  size?: SizeOption;
}

const AnimatedTitle: React.FC<AnimatedTitleProps> = ({
  children,
  className = '',
  variant = 'gradient',
  size = 'lg',
}) => {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
  };

  const variantClasses = {
    gradient: 'bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent',
    neon: 'text-cyan-400',
    glow: 'text-white',
  };

  return (
    <h1
      className={`
        ${sizeClasses[size]}
        ${variantClasses[variant]}
        font-bold
        ${className}
      `}
    >
      {children}
    </h1>
  );
};

export default AnimatedTitle;
